export const LogoMark = ({ size = 30 }) => (
  <svg width={size * 1.25} height={size} viewBox="0 0 40 32" fill="none" data-testid="logo-mark">
    <rect x="0" y="13" width="4" height="6" rx="2" fill="#FFE600" />
    <rect x="6" y="9" width="5" height="14" rx="2.5" fill="#FFE600" />
    <rect x="13" y="3" width="6" height="26" rx="3" fill="#FFE600" />
    <rect x="21" y="3" width="6" height="26" rx="3" fill="#FFE600" />
    <rect x="29" y="9" width="5" height="14" rx="2.5" fill="#FFE600" />
    <rect x="36" y="13" width="4" height="6" rx="2" fill="#FFE600" />
  </svg>
);

export const Logo = () => (
  <div className="flex items-center gap-2.5" data-testid="logo">
    <LogoMark />
    <span className="flex flex-col leading-none">
      <span className="font-display text-2xl font-extrabold uppercase tracking-wide text-white">
        Fit<span className="text-volt">nastic</span>
      </span>
      <span className="mt-0.5 font-mono text-[9px] font-semibold uppercase tracking-[0.4em] text-zinc-500" data-testid="logo-since">
        Since 2015
      </span>
    </span>
  </div>
);
